import Transform from '@ember-data/serializer/transform';
import EmberObject from '@ember/object';
import { A } from '@ember/array';

/**
 * This will deserialize the failed search filters for filtered blast results.
 */
export default Transform.extend({
  /**
   * @inheritDoc
   */
  deserialize: function(serialized) {
    let failedSearchFilters = A();
    serialized.forEach((failedFilterJson) => {
      failedSearchFilters.pushObject(EmberObject.create({
        meta: failedFilterJson['meta'],
        name: failedFilterJson['name'],
        reason: failedFilterJson['reason']
      }));
    });

    return failedSearchFilters;
  },

  /**
   * @inheritDoc
   */
  serialize: function(deserialized) {
    if (!deserialized.length) {
      return [];
    }

    return deserialized;
  }
});
